/* eslint-disable sort-keys */

/**
 * Font Size Constants
 */
export const fontSizes = {
  xsmall: '0.6429em', // 9px never use 8px with the soleil font it's unreadable
  small: '0.7143em', // 10px
  medium: '0.8571em', // 12px
  large: '1em', // 14px
  xlarge: '1.1429em', // 16px
  xxlarge: '1.2857em', // 18px
  mobile: '0.938em',
};

/**
 * Font Weight Constants
 */
export const fontWeights = {
  thin: 300,
  regular: 400,
  semibold: 500,
  bold: 600,
};

/**
 * Spacing Constants
 */
export const spacing = {
  none: '0',
  xxsmall: '4px',
  xsmall: '8px',
  small: '12px',
  medium: '16px',
  large: '24px',
  xlarge: '32px',
  xxlarge: '48px',
};

export const mobile = {
  phoneWidth: 768,
};

/**
 * CSS Media Queries for breakpoints
 * For reference:
 * max-width: screen size <= breakpoint
 * min-width: screen size > breakpoint
 */

/**
 * Query for screens more than 768px wide
 */
export const desktopMediaQuery = '@media(min-width: 768px)';

/**
 * Query for screens 768px wide or less
 */
export const mobileMediaQuery = '@media(max-width: 768px)';
